import { api } from "./client";
import type { APIResponse, AuthResponse } from "./types";

export const authApi = {
	sendOTP: async (email: string) => {
		return api<APIResponse>("/auth/send-otp", {
			method: "POST",
			body: { email },
		});
	},

	verifyOTP: async (email: string, otp: string) => {
		return api<APIResponse<AuthResponse>>("/auth/verify-otp", {
			method: "POST",
			body: { email, otp },
		});
	},
};
